// extracted by mini-css-extract-plugin
export default {"card":"NewsCard_card__6k2hB","cardImg":"NewsCard_cardImg__MGCMw","cardTitle":"NewsCard_cardTitle__Y3wxQ","cardDate":"NewsCard_cardDate__TE-4p"};